import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/public/Home";
import Tickets from "@/pages/public/Tickets";
import Checkout from "@/pages/public/Checkout";
import TicketConfirmation from "@/pages/public/TicketConfirmation";
import Activities from "@/pages/public/Activities";
import ActivityDetail from "@/pages/public/ActivityDetail";
import BookActivity from "@/pages/public/BookActivity";
import MyBooking from "@/pages/public/MyBooking";
import BookingConfirmation from "@/pages/public/BookingConfirmation";
import EventInfo from "@/pages/public/EventInfo";
import FAQ from "@/pages/public/FAQ";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminActivities from "@/pages/admin/AdminActivities";
import AdminParticipants from "@/pages/admin/AdminParticipants";
import AdminTickets from "@/pages/admin/AdminTickets";
import AdminCheckIn from "@/pages/admin/AdminCheckIn";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App font-body">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/tickets/checkout" element={<Checkout />} />
              <Route path="/tickets/confirmation" element={<TicketConfirmation />} />
              <Route path="/activities" element={<Activities />} />
              <Route path="/activities/:slug" element={<ActivityDetail />} />
              <Route path="/book-activity" element={<BookActivity />} />
              <Route path="/my-booking" element={<MyBooking />} />
              <Route path="/booking-confirmation" element={<BookingConfirmation />} />
              <Route path="/event-info" element={<EventInfo />} />
              <Route path="/faq" element={<FAQ />} />
            </Route>

            {/* Admin */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/activities" element={<AdminActivities />} />
              <Route path="/admin/activities/:slug/participants" element={<AdminParticipants />} />
              <Route path="/admin/tickets" element={<AdminTickets />} />
              <Route path="/admin/check-in" element={<AdminCheckIn />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
